import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { togglePortal, updatePortalValues } from '../../redux/actions';


class CaseSpecimenPortal extends Component {
  constructor(props) {
    super(props);
    // STEP 1: create a container <div>
    this.containerEl = document.createElement('div');
    this.externalWindow = null;
  }

  componentDidMount() {
    // STEP 3: open a new browser window and store a reference to it
    this.externalWindow = window.open('', '', `width=1000,
    height=800,
    left=0,
    top=0`);

    // STEP 4: append the container <div> (that has props.children appended to it) to the body of the new window
    if (this.externalWindow) {
      this.externalWindow.document.body.appendChild(this.containerEl);
    }
  }

  componentWillUnmount() {
    // STEP 5: This will fire when this.state.showWindowPortal in the parent component becomes false
    // So we tidy up by closing the window
    if (this.externalWindow) {
      this.externalWindow.close();
    }

    this.props.togglePortal();
    this.props.closeWindowPortal();
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.containerEl);
  }
}

const mapStateToProps = ({ _case }) => {
  const { portalValues } = _case;
  return { portalValues };
};

export default connect(mapStateToProps, { togglePortal, updatePortalValues })(CaseSpecimenPortal);
